(function(){
  function kcInit(){
    var P = window.defined_product_json;
    if(!P){setTimeout(kcInit,200);return;}
    function fv(s){ for(var i=0;i<P.variants.length;i++) if(P.variants[i].title.indexOf(s)!==-1) return P.variants[i]; return null; }

  // Same ladder as the variants (title substrings are the contract) and the bulk page copy
  var RT=[
    {q:1,p:21.90,l:'Starter',u:21.90,vk:'Starter'},
    {q:2,p:39.90,l:'Couple Set',u:19.95,pop:1,vk:'Couple Set'},
    {q:3,p:54.90,l:'Family Set',u:18.30,vk:'Family Set'},
    {q:4,p:67.90,l:'Family Plus',u:16.98,vk:'Family Plus'},
    {q:5,p:79.90,l:'Group Set',u:15.98,vk:'Group Set'}
  ];
  var BK=[
    {n:6,x:14,u:12.5,vk:'Bulk 6-14'},
    {n:15,x:29,u:11,vk:'Bulk 15-29'},
    {n:30,x:98,u:9,vk:'Bulk 30-98'},
    {n:99,x:99999,u:7.5,vk:'Bulk 99+'}
  ];
  var LC=[
    {i:'arizona',n:'Arizona',h:'#b07a56',t:1},{i:'sicilian-brown',n:'Sicilian Brown',h:'#6b5040',t:1},
    {i:'black',n:'Black',h:'#2a2a2a',t:1},{i:'dark-espresso',n:'Dark Espresso',h:'#3e3028',t:1},
    {i:'caramel',n:'Caramel',h:'#c08a64',t:1},{i:'blueberry',n:'Blueberry',h:'#2e3548',t:1},
    {i:'forest-green',n:'Forest Green',h:'#3a5a3a',t:1},{i:'indian-summer',n:'Indian Summer',h:'#d4a04a'},
    {i:'gray-sand',n:'Gray Sand',h:'#d4ccc0'},{i:'turquoise',n:'Turquoise',h:'#4ab8b0'},
    {i:'blush',n:'Blush',h:'#e8c4bc'},{i:'country-grey',n:'Country Gray',h:'#7a7a72'},
    {i:'sangria',n:'Sangria',h:'#5a2030'},{i:'parisian-blossom',n:'Parisian Blossom',h:'#c4868a'},
    {i:'poppy-red',n:'Poppy Red',h:'#d44030'},{i:'lilac',n:'Lilac',h:'#c4a8cc'},
    {i:'fuchsia',n:'Fuchsia',h:'#b03878'}
  ];
  // Two keychains: the stitched rectangle takes initials, the long loop takes a name
  var KT={
    rect:{n:'Initials keychain',s:'Stitched rectangle',ph:['e.g. GWH','e.g. A','e.g. JMD','Initials'],pk:'Rectangle keychains'},
    loop:{n:'Name keychain',s:'Long leather loop',ph:['e.g. Sophia','e.g. JAMES','e.g. Est. 2026','Name'],pk:'Loop keychains'}
  };
  // w = the workshop's own name for the style (cart property), L = letters it holds
  var MG={
    rect:[
      {i:'style-1',n:'Circle Initial',w:'Single Initial in Circle (Style 1)',L:1,s:'One letter in a ring'},
      {i:'style-2',n:'Diamond Initial',w:'Single Initial in Diamond (Style 2)',L:1,s:'One letter in a diamond'},
      {i:'style-3',n:'Flower Initial',w:'Flower Initial (Style 3)',L:1,s:'One letter in a small flourish'},
      {i:'style-4',n:'Straight Caps',w:'Straight Font; All Caps (Style 4)',L:3,s:'Two or three letters in straight capitals'},
      {i:'style-5',n:'Center Initial',w:'Straight Font + Last Name Initial Large in the Middle (Style 5)',L:3,s:'Three letters, the last-name initial large in the middle'},
      {i:'style-6',n:'Circle Monogram',w:'Circle of three initials (Style 6)',L:3,s:'Three letters in a round monogram'},
      {i:'style-7',n:'Vine Monogram',w:'Vine Monogram (Style 7)',L:3,s:'Three letters in ornate script'}
    ],
    loop:[
      {i:'straight',n:'Straight',w:'Straight',L:40,s:'Clean capitals for any length of name'},
      {i:'cursive',n:'Cursive',w:'Cursive',L:40,s:'Flowing script, best for a first name'}
    ]
  };
  var ALIAS={'circle-initial':'style-1','diamond-initial':'style-2','flower-initial':'style-3','floral-initial':'style-3','straight-caps':'style-4','minimalist':'style-4','center-initial':'style-5','circle-monogram':'style-6','vine-monogram':'style-7'};
  function qp(k){try{return (new URLSearchParams(location.search).get(k)||'').toLowerCase();}catch(x){return '';}}

  // The page's own leather leads the swatch row; ?color=caramel beats the handle
  var DEF_C=(function(){
    var q=qp('color').replace(/^country-gray$/,'country-grey');
    var h=(P.handle||'').replace(/-in-country-gray-/,'-in-country-grey-');
    var qi=-1;for(var j0=0;j0<LC.length;j0++)if(LC[j0].i===q)qi=j0;
    for(var i=0;i<LC.length;i++)if(qi>=0?i===qi:h.indexOf('-in-'+LC[i].i+'-leather')!==-1){
      var c=LC.splice(i,1)[0];
      if(!c.t){c.t=1;for(var j=LC.length-1;j>=0;j--)if(LC[j].t){delete LC[j].t;break;}}
      LC.unshift(c);return c.i;
    }
    return 'arizona';
  })();
  // The loop listing opens on names; design listings open on their own style (?type=loop, ?style=vine-monogram)
  var DEF_K=qp('type')==='loop'||qp('type')==='rect'?qp('type'):(P.handle==='leather-keychain'?'loop':'rect');
  var DEF_M=(function(){
    var H={'floral-initial-keychain-in-lilac-leather':'style-3','minimalist-initials-keychain-in-caramel-leather':'style-4'};
    var q=qp('style');q=ALIAS[q]||q;
    var d=q||H[P.handle]||'';
    for(var k=0;k<MG.rect.length;k++)if(MG.rect[k].i===d)return d;
    return 'style-4';
  })();
  function defM(k){return k==='rect'?DEF_M:'straight';}
  var EM='leatherius.woodman@gmail.com';

  function fc(id){for(var i=0;i<LC.length;i++)if(LC[i].i===id)return LC[i];return LC[0];}
  function fm(k,id){var a=MG[k];for(var i=0;i<a.length;i++)if(a[i].i===id)return a[i];return a[0];}
  function esc(s){return s?String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'):''}
  function imgUrl(type,id){var A=window.KC_ASSETS;return (A&&A[type]&&A[type][id])?A[type][id]:'';}
  function money(v){return '$'+v.toFixed(2);}

  var S={m:qp('tab')==='bulk'?'bulk':'retail',ti:0,keys:[],gd:'',nt:'',bq:'',bk:DEF_K};
  function mkK(q){var t=[];for(var i=0;i<q;i++)t.push(S.keys[i]||{t:'',g:false,c:DEF_C,k:DEF_K,m:defM(DEF_K),e:false});S.keys=t;}
  mkK(RT[S.ti].q);

  var root=document.getElementById('kc-configurator');
  if(!root) return;

  // ============ Full re-render (ONLY for structural changes: tier/tab) ============
  function R(){
    var h='';
    h+='<div class="lt-hd-sub">Personalized Leather Keychains</div>';
    h+='<h1 class="lt-hd-title lt-hd-title-sm">'+esc(P.title)+'</h1>';
    h+='<p class="lt-hd-desc">Full-grain cowhide, stamped by hand on one side. The stitched rectangle takes initials in seven monogram styles, and the long loop takes a name of any length. 17 leathers, plain press or gold foil.</p>';
    h+='<p class="lt-hd-free">Free US shipping</p>';
    h+='<button type="button" class="lt-lm-jump" id="lt-lm-jump"><span class="lt-lm-jump-dot"></span>Your logo, pressed into leather. <u>Mockup in minutes</u> ↓</button>';
    h+='<div class="lt-tabs"><button class="lt-tab'+(S.m==='retail'?' on':'')+'" data-m="retail">Sets (1–5)</button><button class="lt-tab'+(S.m==='bulk'?' on':'')+'" data-m="bulk">Bulk (6+)</button></div>';
    h+=S.m==='retail'?rRet():rBulk();
    h+=rLogo();
    h+='<div class="lt-ct"><p class="lt-ct-t"><strong>Have questions?</strong> Ask us anything about names or your deadline.</p><div class="lt-ct-bs"><button class="lt-ct-b" id="lt-chat">💬 Live Chat</button><button class="lt-ct-b" id="lt-eml">✉️ Copy Email</button></div><p class="lt-ct-n">Real humans here – sometimes we reply instantly, sometimes it takes a bit. Small business life!</p></div>';
    root.innerHTML=h;
    bind();
  }

  function rRet(){
    var tr=RT[S.ti],h='<div class="lt-fi">';
    h+='<div class="lt-tiers">';
    for(var i=0;i<RT.length;i++){
      var t=RT[i],a=S.ti===i,sv=t.q>1?Math.round((1-t.u/21.90)*100):0;
      h+='<button class="lt-tr'+(a?' on':'')+'" data-ti="'+i+'"><div class="lt-tr-rd"><div class="lt-tr-dt"></div></div><div class="lt-tr-nfo"><span class="lt-tr-nm">'+t.l+'</span>';
      if(t.pop)h+='<span class="lt-bdg lt-bdg-p">Popular</span>';
      if(sv>0)h+='<span class="lt-bdg lt-bdg-s">-'+sv+'%</span>';
      h+='<span class="lt-tr-sub">'+t.q+(t.q===1?' keychain':' keychains');
      if(t.q>1)h+=' · '+money(t.u)+' each';
      h+='</span></div><span class="lt-tr-pr">'+money(t.p)+'</span></button>';
    }
    h+='</div>';
    h+='<label class="lt-lbl">Personalize '+(tr.q===1?'Your Keychain':'Each Keychain')+' <span style="color:#b83a2a">*</span></label><div class="lt-trs">';
    for(var j=0;j<tr.q;j++) h+=rKey(j);
    h+='</div>';
    h+='<div class="lt-dl kc-nt"><label class="lt-lbl">Note for the workshop <span style="font-weight:400;text-transform:none;letter-spacing:0">(optional)</span></label><textarea id="kc-nt" rows="2" placeholder="A custom layout, a date or a small symbol? Describe it here and we confirm a proof by email before stamping.">'+esc(S.nt)+'</textarea></div>';
    h+='<div class="lt-dl"><label class="lt-lbl">Gift Deadline <span style="font-weight:400;text-transform:none;letter-spacing:0">(optional) – we RUSH if possible</span></label><input type="text" id="lt-gd" value="'+esc(S.gd)+'" placeholder="We average a 2-week turnaround. Tell us your event date if it’s sooner."></div>';
    var dc=(tr.p*0.9).toFixed(2),ds=(tr.p*0.1).toFixed(2);
    h+='<div class="lt-sum">';
    h+='<div class="lt-sr"><span class="lt-sr-l">'+tr.l+' · '+tr.q+(tr.q===1?' keychain':' keychains')+'</span><span class="lt-sr-v lt-sr-x">'+money(tr.p)+'</span></div>';
    h+='<div class="lt-sr"><span class="lt-sr-l lt-sr-d">Site-wide 10% off</span><span class="lt-sr-v lt-sr-d">−$'+ds+'</span></div>';
    h+='<div class="lt-sr"><span class="lt-sr-l lt-sr-f">Personalization + Shipping</span><span class="lt-sr-fv">FREE</span></div>';
    h+='<div class="lt-st"><span class="lt-st-l">Total</span><span class="lt-st-p">$'+dc+'</span></div>';
    h+='<p class="kc-err" id="kc-err" role="alert"></p>';
    h+='<button class="lt-atc" id="lt-ac">Add to Cart</button>';
    h+='</div></div>';
    return h;
  }

  function rKey(idx){
    var kg=S.keys[idx];if(!kg)return'';
    var cl=fc(kg.c),mn=fm(kg.k,kg.m),kt=KT[kg.k];
    var h='<div class="lt-tg kc-row" data-row="'+idx+'">';
    h+='<div class="kc-ty" role="radiogroup" aria-label="Keychain '+(idx+1)+' type">';
    for(var key in KT){var on=kg.k===key,ti=imgUrl('type',key);
      h+='<button type="button" class="kc-ty-b'+(on?' on':'')+'" data-ty="'+idx+':'+key+'" role="radio" aria-checked="'+on+'">'+(ti?'<span class="kc-ty-i" style="background-image:url('+ti+')"></span>':'')+'<span class="kc-ty-t"><b>'+KT[key].n+'</b><span>'+KT[key].s+'</span></span></button>';}
    h+='</div>';
    h+='<div class="lt-tg-top">';
    h+='<div class="lt-tg-n" data-num style="background:'+cl.h+'">'+(idx+1)+'</div>';
    h+='<input class="lt-tg-inp" type="text" data-tg="'+idx+'" value="'+esc(kg.t)+'" maxlength="'+mn.L+'" placeholder="'+(mn.L===1?'One letter':kt.ph[Math.min(idx,3)])+'" aria-label="'+(kg.k==='rect'?'Initials':'Name')+' for keychain '+(idx+1)+'"'+(kg.k==='rect'?' autocapitalize="characters"':'')+'>';
    h+='<button type="button" class="lt-gt '+(kg.g?'lt-gt-on':'lt-gt-off')+'" data-gl="'+idx+'"><div class="lt-gt-k"></div><span class="lt-gt-l">'+(kg.g?'Gold ✦':'Plain')+'</span></button>';
    h+='</div>';
    h+='<div class="lt-mp"><span class="lt-mp-lbl">'+(kg.k==='rect'?'Style':'Font')+'</span><div class="lt-mts">';
    var ms=MG[kg.k];
    for(var m=0;m<ms.length;m++){
      var s=ms[m],murl=imgUrl('style',s.i);
      h+='<button type="button" class="lt-mt'+(kg.m===s.i?' on':'')+'" data-mg="'+idx+':'+s.i+'" title="'+s.n+'"'+(murl?' style="background-image:url('+murl+')"':'')+'></button>';
    }
    h+='</div></div>';
    h+='<div class="lt-mp-nm"><strong>'+mn.n+'</strong><span>&nbsp;– '+mn.s+'</span></div>';
    h+='<div class="lt-cs"><span class="lt-cs-lbl">Leather</span><div class="lt-sw">';
    var show=kg.e?LC:LC.filter(function(c){return c.t;});
    for(var k=0;k<show.length;k++){
      var c=show[k],lurl=imgUrl('leather',c.i);
      h+='<button type="button" class="lt-s'+(kg.c===c.i?' on':'')+'" style="background-color:'+c.h+(lurl?';background-image:url('+lurl+')':'')+'" data-cl="'+idx+':'+c.i+'" title="'+c.n+'"></button>';
    }
    if(!kg.e)h+='<button type="button" class="lt-sm" data-ex="'+idx+'">+'+(LC.length-LC.filter(function(c){return c.t;}).length)+'</button>';
    else h+='<button type="button" class="lt-sm" data-co="'+idx+'" style="border:none;background:none">less</button>';
    h+='</div><span class="lt-cn">'+cl.n+'</span></div>';
    if(idx===0) h+='<div class="lt-hint">'+(kg.k==='rect'
      ?'Styles 1–3 hold one letter, Styles 4–7 hold two or three. For a three-letter monogram the traditional order reads <em>First · Last · Middle</em>.'
      :'Any name fits the loop, from <em>Jo</em> to <em>Christopher</em>. A date or a short phrase works too.')+' Each keychain is stamped on one side and carries a name or a design, never both.</div>';
    h+='</div>';
    return h;
  }

  function tierFor(n){for(var i=0;i<BK.length;i++)if(n>=BK[i].n&&n<=BK[i].x)return BK[i];return null;}
  function rBulkPrice(){
    var n=parseInt(S.bq)||0,tr=tierFor(n),h='';
    if(n>=6&&tr){
      var tot=n*tr.u,dt=(tot*0.9).toFixed(2),dv=(tot*0.1).toFixed(2),du=(tr.u*0.9).toFixed(2);
      h+='<div class="lt-bp">';
      h+='<div class="lt-sr"><span style="font-size:13px;color:#3a3a38">'+n+' '+KT[S.bk].pk.toLowerCase()+'</span><span class="lt-sr-v lt-sr-x">'+money(tot)+'</span></div>';
      h+='<div class="lt-sr"><span class="lt-sr-l lt-sr-d">10% off in cart</span><span class="lt-sr-v lt-sr-d">−$'+dv+'</span></div>';
      h+='<div class="lt-sr"><span class="lt-sr-f">Logo setup + Shipping</span><span class="lt-sr-fv">FREE</span></div>';
      h+='<div class="lt-st"><span class="lt-st-l">You pay</span><div style="text-align:right"><span class="lt-st-p">$'+dt+'</span><span style="font-size:10.5px;color:#8a8575;display:block;margin-top:1px">$'+du+' each after discount</span></div></div>';
      h+='</div>';
      h+='<button class="lt-atc" id="lt-ba">Add to Cart</button>';
    }
    if(n>0&&n<6)h+='<p class="lt-bk-mw">Bulk starts at 6. For 1 to 5, see the sets!</p>';
    return h;
  }
  function rBulk(){
    var n=parseInt(S.bq)||0,tr=tierFor(n);
    var h='<div class="lt-fi"><div class="lt-bk">';
    h+='<span class="lt-bk-t">Bulk Orders</span><span class="lt-bk-bg">6+ keychains</span>';
    h+='<p class="lt-bk-d">Your logo on every keychain, or a different name on each. Logo setup is free.</p>';
    h+='<div class="lt-kc">';
    for(var key in KT){h+='<button type="button" class="lt-ko'+(S.bk===key?' on':'')+'" data-bk="'+key+'"><span class="lt-ko-r"><span class="lt-ko-d"></span></span><span class="lt-ko-n">'+KT[key].pk+'</span><span class="lt-ko-s">'+(key==='rect'?'Stacked or square logos, initials':'Wide logos, names')+'</span></button>';}
    h+='</div>';
    h+='<div class="lt-chs">';
    for(var j=0;j<BK.length;j++){
      var t=BK[j],a=tr&&tr.n===t.n;
      h+='<div class="lt-ch'+(a?' on':'')+'"><div class="lt-ch-r">'+(t.x<99999?t.n+'–'+t.x:t.n+'+')+'</div><div class="lt-ch-p">'+money(t.u)+'</div><div class="lt-ch-u">each</div></div>';
    }
    h+='</div>';
    h+='<input type="number" class="lt-bq" id="lt-bqi" min="6" value="'+esc(S.bq)+'" placeholder="Enter quantity (6+)">';
    h+='<div id="lt-bp-wrap">'+rBulkPrice()+'</div>';
    h+='<div class="lt-bk-perks"><span>✓ Free shipping</span><span>✓ Free logo setup</span><span>✓ Free mockup</span></div>';
    h+='<div class="lt-bk-dl"><label>Deadline <span style="font-weight:400;text-transform:none;letter-spacing:0">(optional) – we RUSH if possible</span></label><input type="text" id="lt-bdl" placeholder="We average a 2-week turnaround. Tell us your event date if it’s sooner."></div>';
    h+='<div class="lt-bk-em"><span style="font-size:13px;flex-shrink:0;margin-top:1px">✉️</span><p><strong>No need to send the logo or the names at checkout.</strong> Place your order, then email us the logo file or the name list along with the leather colors. Each keychain carries a logo or a name, never both. We confirm everything before production.</p></div>';
    h+='</div></div>';
    return h;
  }

  // ============ Logo mockup request (always visible, both tabs) ============
  var LMK='lt-logo-mockup';
  S.lm={w:'',e:'',n:'',on:false,sent:null};
  try{var lmSaved=JSON.parse(localStorage.getItem(LMK)||'null');if(lmSaved&&lmSaved.w)S.lm.sent=lmSaved;}catch(e){}

  function rLogo(){
    var L=S.lm,h='<div class="lt-lm" id="lt-lm">';
    h+='<div class="lt-lm-hd"><svg class="lt-lm-art" viewBox="0 0 64 84" aria-hidden="true"><defs><radialGradient id="ltlmg" cx="35%" cy="25%" r="85%"><stop offset="0" stop-color="#b98260"/><stop offset="1" stop-color="#8a5a3c"/></radialGradient></defs><rect x="24" y="2" width="16" height="22" rx="8" fill="none" stroke="#8a5a3c" stroke-width="5"/><rect x="5" y="14" width="54" height="66" rx="9" fill="url(#ltlmg)"/><rect x="9" y="18" width="46" height="58" rx="6" fill="none" stroke="#f0d9b5" stroke-opacity=".5" stroke-dasharray="2.2 2.4"/><circle cx="32" cy="22" r="3.2" fill="#2b211b"/><g font-family="Cormorant Garamond,Georgia,serif" font-size="15" font-weight="600" text-anchor="middle"><circle cx="32" cy="50.7" r="12.5" fill="none" stroke="#e8c79a" stroke-opacity=".55" stroke-width="1.6"/><circle cx="32" cy="50" r="12.5" fill="none" stroke="#5a3826" stroke-width="1.6"/><text x="32" y="56.2" fill="#e8c79a" fill-opacity=".5">L</text><text x="32" y="55.4" fill="#5e3a27">L</text></g></svg>';
    h+='<div><span class="lt-lm-k">Logo mockup \u00b7 5\u201315 minutes</span><h3 class="lt-lm-t">See your logo pressed into a leather keychain</h3>';
    h+='<p class="lt-lm-s">Share your website or company name. We\u2019ll find your logo and send you a mockup by email.</p></div></div>';
    if(L.sent){
      h+=rProgress(L.sent);
      h+='<button type="button" class="lt-lm-again" id="lt-lm-again">Request another</button>';
    } else {
      // Real Shopify contact form (Shopify's hCaptcha binds to it), posted into a hidden iframe
      h+='<form class="lt-lm-form" id="lt-lm-form" action="/contact#lt-lm" method="post" target="lt-lm-sink" accept-charset="UTF-8" novalidate>';
      h+='<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[body]" id="lt-lm-body" value="">';
      h+='<div class="lt-lm-f">';
      h+='<input class="lt-lm-i" id="lt-lm-w" name="contact[Website or company]" type="text" autocomplete="organization" value="'+esc(L.w)+'" placeholder="Website or company name" aria-label="Your website or company name">';
      h+='<input class="lt-lm-i" id="lt-lm-e" name="contact[email]" type="email" autocomplete="email" inputmode="email" value="'+esc(L.e)+'" placeholder="Email for the mockup" aria-label="Your email">';
      h+='</div>';
      if(L.on) h+='<textarea class="lt-lm-i lt-lm-ta" id="lt-lm-n" rows="2" placeholder="E.g. show it in Black and Caramel too, or a question about quantity or dates">'+esc(L.n)+'</textarea>';
      else h+='<button type="button" class="lt-lm-add" id="lt-lm-add">+ Add a note<span class="lt-lm-add-h">, e.g. a few leather colors to see or a question</span></button>';
      h+='<p class="lt-lm-err" id="lt-lm-err" role="alert"></p>';
      h+='<button type="submit" class="lt-lm-b" id="lt-lm-b">See it in leather</button>';
      h+='<p class="lt-lm-fine">Should a sharper logo file help, we\u2019ll write to you.</p>';
      h+='</form>';
    }
    h+='<p class="lt-lm-pay">For team orders we accept cards and ACH bank transfers.</p>';
    h+='</div>';
    return h;
  }

  // ---- Live progress (requests that went through the mockup queue carry id + token) ----
  var LM_API='https://bilbotherobot.com/mockup-generator/api';
  // Signed pass from the API, sent with the form; scripts that skip the page never get one
  var lmPassV='',lmPassT=0;
  function lmPass(){if(lmPassV&&Date.now()-lmPassT<3600000)return Promise.resolve(lmPassV);
    return fetch(LM_API+'/pass',{cache:'no-store'}).then(function(r){return r.ok?r.json():{};})
    .then(function(j){lmPassV=j.pass||'';lmPassT=Date.now();return lmPassV;}).catch(function(){return '';});}
  // One generic status line: the steps of our process stay private
  function lmEta(st,short){
    var eta=st.estimatedSecondsRemaining;
    return eta>60?'about '+Math.round(eta/60)+' min'+(short?'':' left'):'almost ready';
  }
  var lmPoll=null;
  if(S.lm.sent&&S.lm.sent.id)setTimeout(pollLogo,800);

  // Waiting on the customer: Theo emailed them for a logo file or with a question
  function lmAskText(rec){
    if((rec.st||{}).ask==='question')return '<strong>A quick question first.</strong> Theo just emailed '+esc(rec.e)+'. Reply there, and your mockup follows in the same thread. Should the email be missing, please look in the Spam or Promotions folder.';
    return '<strong>One thing from you.</strong> Theo just emailed '+esc(rec.e)+' asking for your logo file. Reply with it attached, and your mockup follows in the same thread within minutes. Should the email be missing, please look in the Spam or Promotions folder.';
  }
  function rProgress(rec){
    var st=rec.st||{},h='<div class="lt-lm-ok" id="lt-lm-prog">';
    var status=st.status||'queued';
    if(status==='delivered'&&st.sentInThread){
      h+='<span class="lt-lm-ok-i">✓</span><div><strong>Your mockup is on its way.</strong> Theo just sent it to '+esc(rec.e)+', in the same email thread. Should it be missing, please look in the Spam or Promotions folder.</div></div>';
      return h;
    }
    if(status==='delivered'){
      h+='<span class="lt-lm-ok-i">✓</span><div><strong>Your mockup is ready.</strong> Theo from our team just emailed '+esc(rec.e)+' to confirm the request is yours. Reply to that email and the mockup arrives in the same thread. Should the note be missing, please look in the Spam or Promotions folder.</div></div>';
      return h;
    }
    if(status==='needs_info'){
      h+='<span class="lt-lm-ok-i">✉</span><div>'+lmAskText(rec)+'</div></div>';
      return h;
    }
    if(status==='needs_review'||status==='failed'||status==='email_failed'||status==='expired'){
      h+='<span class="lt-lm-ok-i">✓</span><div><strong>Thank you. We’re finishing this one by hand.</strong> Your mockup for '+esc(rec.w)+' will reach '+esc(rec.e)+' by email shortly.</div></div>';
      return h;
    }
    if(!rec.id){
      h+='<span class="lt-lm-ok-i">✓</span><div><strong>Thank you. Your mockup for '+esc(rec.w)+' is underway.</strong> It will arrive at '+esc(rec.e)+', usually within 5–15 minutes. Please check the Spam folder too.</div></div>';
      return h;
    }
    var pct=Math.max(4,Math.min(99,st.progressPercent||4)),label='Work in progress',etaTxt=lmEta(st);
    h+='<span class="lt-lm-spin" aria-hidden="true"></span><div class="lt-lm-pw"><strong>Your mockup for '+esc(rec.w)+' is underway.</strong>';
    h+='<div class="lt-lm-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="'+pct+'"><i style="width:'+pct+'%"></i></div>';
    h+='<div class="lt-lm-stage"><span>'+label+'</span><span>'+etaTxt+'</span></div>';
    h+='<div class="lt-lm-sub">Once it is ready, Theo will email '+esc(rec.e)+'; should it be missing, the Spam folder is the place to look. Keep browsing, and we’ll tell you here the moment it’s ready.</div></div></div>';
    return h;
  }

  // ---- Floating status: live progress while the card is off screen, then a "sent" notice ----
  var lmMiniEl=null,lmCardSeen=true,lmIO=null,lmMiniT=null,lmTitle=null;
  function lmWatchCard(){
    if(!('IntersectionObserver' in window))return;
    if(lmIO)lmIO.disconnect();
    var box=root.querySelector('#lt-lm');if(!box)return;
    lmIO=new IntersectionObserver(function(es){lmCardSeen=es[0].isIntersecting;lmMini();});
    lmIO.observe(box);
  }
  function lmMini(justSent,justAsked){
    var rec=S.lm.sent,st=(rec&&rec.st)||{};
    var active=!!(rec&&rec.id&&!/^(delivered|needs_review|needs_info|failed|email_failed|expired)$/.test(st.status));
    if(!lmMiniEl){
      lmMiniEl=document.createElement('button');lmMiniEl.type='button';lmMiniEl.className='lt-lm-mini';lmMiniEl.hidden=true;
      lmMiniEl.setAttribute('aria-live','polite');document.body.appendChild(lmMiniEl);
      lmMiniEl.addEventListener('click',function(){
        var b=root.querySelector('#lt-lm');if(b)b.scrollIntoView({behavior:'smooth',block:'center'});
        if(lmMiniEl.classList.contains('done'))lmMiniEl.hidden=true;
      });
    }
    if(justSent||justAsked){
      clearTimeout(lmMiniT);
      lmMiniEl.className='lt-lm-mini done';
      lmMiniEl.innerHTML=justAsked
        ?'<span class="lt-lm-ok-i">✉</span><span><strong>One thing from you</strong><br>Theo emailed '+esc(rec.e)+'. Reply there, and your mockup follows. Please check Spam if it’s missing.</span>'
        :st.sentInThread
        ?'<span class="lt-lm-ok-i">✓</span><span><strong>Your logo mockup is ready</strong><br>Theo sent it to '+esc(rec.e)+', in your email thread. Please check Spam if it’s missing.</span>'
        :'<span class="lt-lm-ok-i">✓</span><span><strong>Your logo mockup is ready</strong><br>Reply to Theo’s email at '+esc(rec.e)+' and it’s yours. Please check Spam if it’s missing.</span>';
      lmMiniEl.hidden=false;
      lmMiniT=setTimeout(function(){lmMiniEl.hidden=true;},20000);
      if(document.hidden&&lmTitle===null){lmTitle=document.title;document.title=(justAsked?'✉ Reply needed · ':'✓ Mockup ready · ')+lmTitle;}
      return;
    }
    if(lmMiniEl.classList.contains('done')&&!lmMiniEl.hidden)return;
    if(!active||lmCardSeen){lmMiniEl.hidden=true;return;}
    var pct=Math.max(4,Math.min(99,st.progressPercent||4));
    lmMiniEl.className='lt-lm-mini';
    lmMiniEl.innerHTML='<span class="lt-lm-spin" aria-hidden="true"></span><span><strong>Logo mockup</strong> · Work in progress · '+lmEta(st,1)+
      '<i class="lt-lm-mini-bar"><i style="width:'+pct+'%"></i></i></span>';
    lmMiniEl.hidden=false;
  }
  document.addEventListener('visibilitychange',function(){if(!document.hidden&&lmTitle!==null){document.title=lmTitle;lmTitle=null;}});

  function pollLogo(){
    clearTimeout(lmPoll);
    var rec=S.lm.sent;if(!rec||!rec.id)return;
    var done=rec.st&&/^(delivered|needs_review|failed|email_failed|expired)$/.test(rec.st.status);
    if(done)return;
    fetch(LM_API+'/requests/'+encodeURIComponent(rec.id),{headers:{Authorization:'Bearer '+rec.tk},cache:'no-store'})
    .then(function(r){if(r.status===404){rec.st={status:'expired'};return null;}return r.ok?r.json():null;})
    .then(function(st){
      var was=rec.st&&rec.st.status;
      if(st)rec.st=st;
      var justSent=rec.st&&rec.st.status==='delivered'&&was!=='delivered';
      var justAsked=rec.st&&rec.st.status==='needs_info'&&was!=='needs_info';
      try{localStorage.setItem(LMK,JSON.stringify(rec));}catch(x){}
      var box=root.querySelector('#lt-lm-prog');
      if(box){var tmp=document.createElement('div');tmp.innerHTML=rProgress(rec);box.parentNode.replaceChild(tmp.firstChild,box);}
      lmMini(justSent,justAsked);
    })
    .catch(function(){})
    .then(function(){
      // While Theo waits on the customer's reply, check back more slowly
      var waiting=rec.st&&rec.st.status==='needs_info';
      if(!(rec.st&&/^(delivered|needs_review|failed|email_failed|expired)$/.test(rec.st.status)))
        lmPoll=setTimeout(pollLogo,waiting?(document.hidden?60000:15000):(document.hidden?20000:5000));
    });
  }

  function lmTrack(e){
    try{var T=window.tidioChatApi;if(T){T.setVisitorData&&T.setVisitorData({email:e});T.addVisitorTags&&T.addVisitorTags(['logo-mockup']);}}catch(x){}
    try{window.Shopify&&Shopify.analytics&&Shopify.analytics.publish&&Shopify.analytics.publish('logo_mockup_request',{product:P.title,mode:S.m});}catch(x){}
    try{window.gtag&&gtag('event','generate_lead',{method:'logo_mockup'});}catch(x){}
  }

  function submitLogo(d){
    var fd=new FormData();
    fd.append('email',d.e);fd.append('company',d.w);fd.append('consent','1');
    if(S.lm.n)fd.append('note',S.lm.n.slice(0,600));
    fd.append('context',lmContext().slice(0,1200));fd.append('source','store-keychains');
    var key='lt-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,12);
    lmPass().then(function(p){if(!p)throw new Error('pass');fd.append('pass',p);
    return fetch(LM_API+'/requests',{method:'POST',body:fd,headers:{'Idempotency-Key':key}});})
    .then(function(r){
      if(r.status===429){var x=new Error('rate');x.rate=1;throw x;}
      if(!r.ok)throw new Error('api_'+r.status);
      return r.json();
    })
    .then(function(j){
      var rec={w:d.w,e:d.e,t:Date.now(),id:j.requestId,tk:j.requestToken,st:{status:'queued',progressPercent:4,estimatedSecondsRemaining:450}};
      S.lm.sent=rec;try{localStorage.setItem(LMK,JSON.stringify(rec));}catch(x){}
      lmTrack(d.e);swapLogo();pollLogo();
    })
    .catch(function(x){
      if(x&&x.rate){
        var b=root.querySelector('#lt-lm-b'),err=root.querySelector('#lt-lm-err');
        if(b){b.disabled=false;b.textContent='See it in leather';}
        if(err)err.textContent='We already have a few requests from you this hour. We’ll be in touch by email shortly.';
        return;
      }
      contactFallback(d);
    });
  }

  // Backup route: Shopify contact form (hCaptcha) into a hidden iframe, lands in our inbox
  function contactFallback(d){
    var form=root.querySelector('#lt-lm-form');if(!form)return;
    var bf=root.querySelector('#lt-lm-body');if(bf)bf.value=d.body;
    watchSink(d.w,d.e,d.body);
    S.lm.viaContact=true;
    try{form.requestSubmit?form.requestSubmit():form.submit();}finally{S.lm.viaContact=false;}
  }

  // "Product handle" points the mockup worker at the keychain blank (custom-goods/<handle>.jpg)
  function lmContext(){
    var parts=['Product: '+P.title,'Product handle: custom-logo-leather-keychains','Page: '+location.origin+location.pathname];
    if(S.m==='bulk'){
      parts.push('Was viewing: Bulk tab'+(S.bq?', '+S.bq+' keychains':'')+', '+KT[S.bk].pk);
      var dl=root.querySelector('#lt-bdl');if(dl&&dl.value)parts.push('Deadline: '+dl.value);
    } else {
      var k0=S.keys[0];
      parts.push('Was viewing: Sets tab, '+RT[S.ti].l+', keychain 1 '+(k0.k==='rect'?'rectangle':'loop')+' in '+fc(k0.c).n);
      if(S.gd)parts.push('Gift deadline: '+S.gd);
    }
    return parts.join('\n');
  }

  // Gallery caption on the real logo-stamp photo jumps to the card (delegated: the gallery lives outside root)
  document.addEventListener('click',function(ev){
    var cap=ev.target.closest&&ev.target.closest('.lt-cap');if(!cap)return;
    var box=root.querySelector('#lt-lm');if(!box)return;
    ev.preventDefault();
    box.scrollIntoView({behavior:'smooth',block:'center'});
    box.classList.remove('lt-lm-glow');void box.offsetWidth;box.classList.add('lt-lm-glow');
    var f=root.querySelector('#lt-lm-w');if(f)setTimeout(function(){f.focus({preventScroll:true});},450);
  });
  function bindLogo(){
    lmWatchCard();
    var jump=root.querySelector('#lt-lm-jump');
    if(jump) jump.addEventListener('click',function(){
      var box=root.querySelector('#lt-lm');if(!box)return;
      box.scrollIntoView({behavior:'smooth',block:'center'});
      box.classList.remove('lt-lm-glow');void box.offsetWidth;box.classList.add('lt-lm-glow');
      var f=root.querySelector('#lt-lm-w');if(f)setTimeout(function(){f.focus({preventScroll:true});},450);
    });
    var w=root.querySelector('#lt-lm-w'),e=root.querySelector('#lt-lm-e'),n=root.querySelector('#lt-lm-n');
    if(w) w.addEventListener('input',function(){S.lm.w=this.value;});
    if(e) e.addEventListener('input',function(){S.lm.e=this.value;});
    if(n) n.addEventListener('input',function(){S.lm.n=this.value;});
    var add=root.querySelector('#lt-lm-add');
    if(add) add.addEventListener('click',function(){
      S.lm.on=true;
      var ta=document.createElement('textarea');
      ta.className='lt-lm-i lt-lm-ta';ta.id='lt-lm-n';ta.rows=2;
      ta.placeholder='E.g. show it in Black and Caramel too, or a question about quantity or dates';
      ta.addEventListener('input',function(){S.lm.n=this.value;});
      add.parentNode.replaceChild(ta,add);ta.focus();
    });
    var form=root.querySelector('#lt-lm-form');
    if(form){
      // Our listener is attached before Shopify's captcha binds (on focusin), so it runs first.
      // Normal path: we take over and post to the mockup queue. Only the contact fallback lets
      // the native submit continue into Shopify's captcha + hidden-iframe POST.
      form.addEventListener('submit',function(ev){
        if(S.lm.viaContact)return;
        ev.preventDefault();ev.stopImmediatePropagation();
        var d=sendLogo();if(d)submitLogo(d);
      });
      try{if(window.Shopify&&Shopify.captcha&&Shopify.captcha.protect)Shopify.captcha.protect(form);}catch(x){}
    }
    var again=root.querySelector('#lt-lm-again');
    if(again) again.addEventListener('click',function(){
      clearTimeout(lmPoll);S.lm.sent=null;S.lm.w='';S.lm.n='';if(lmMiniEl)lmMiniEl.hidden=true;
      try{localStorage.removeItem(LMK);}catch(x){}
      swapLogo();var f=root.querySelector('#lt-lm-w');if(f)f.focus();
    });
  }

  function swapLogo(){
    var box=root.querySelector('#lt-lm');if(!box)return;
    var tmp=document.createElement('div');tmp.innerHTML=rLogo();
    box.parentNode.replaceChild(tmp.firstChild,box);
    bindLogo();
  }

  function sendLogo(){
    var L=S.lm,err=root.querySelector('#lt-lm-err'),b=root.querySelector('#lt-lm-b');
    var w=(L.w||'').trim(),e=(L.e||'').trim();
    function fail(msg,id){if(err)err.textContent=msg;var f=root.querySelector('#'+id);if(f){f.classList.add('bad');f.focus();}}
    root.querySelectorAll('.lt-lm-i.bad').forEach(function(x){x.classList.remove('bad');});
    if(w.length<2){fail('Please add your website or company name.','lt-lm-w');return null;}
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e)){fail('Please add the email where the mockup should go.','lt-lm-e');return null;}
    if(b&&b.disabled) return null;
    if(err)err.textContent='';
    if(b){b.disabled=true;b.textContent='Sending…';}
    var body='LOGO MOCKUP REQUEST\n\nWebsite / company: '+w+'\nEmail: '+e+(L.n?'\nNote: '+L.n:'')+'\n\n'+lmContext();
    return {w:w,e:e,body:body};
  }

  // Hidden iframe receives the POST response; Shopify redirects to ?contact_posted=true on success
  function watchSink(w,e,body){
    var sink=document.getElementById('lt-lm-sink');
    if(!sink){
      sink=document.createElement('iframe');
      sink.name='lt-lm-sink';sink.id='lt-lm-sink';sink.title='Logo mockup request';sink.setAttribute('aria-hidden','true');sink.tabIndex=-1;
      sink.style.cssText='position:absolute;width:1px;height:1px;border:0;left:-9999px;top:0;visibility:hidden';
      document.body.appendChild(sink);
    }
    var done=false;
    function finish(ok){
      if(done)return;done=true;clearTimeout(to);sink.removeEventListener('load',onLoad);
      if(ok){
        var rec={w:w,e:e,t:Date.now()};
        S.lm.sent=rec;try{localStorage.setItem(LMK,JSON.stringify(rec));}catch(x){}
        lmTrack(e);
        swapLogo();
      } else {
        var b=root.querySelector('#lt-lm-b'),err=root.querySelector('#lt-lm-err');
        if(b){b.disabled=false;b.textContent='See it in leather';}
        if(err){
          var mail='mailto:'+EM+'?subject='+encodeURIComponent('Logo mockup request: '+w)+'&body='+encodeURIComponent(body);
          err.innerHTML='Our form hiccuped. <a href="'+mail+'">Send it by email instead</a> and we’ll take it from there.';
        }
      }
    }
    function onLoad(){
      var href='';try{href=sink.contentWindow.location.href;}catch(x){}
      if(!href||href==='about:blank')return;
      finish(/contact_posted=true/.test(href)&&!/challenge/.test(href));
    }
    sink.addEventListener('load',onLoad);
    // Long timeout: an hCaptcha puzzle may appear for suspicious traffic and needs human time
    var to=setTimeout(function(){finish(false);},90000);
    setTimeout(function(){
      if(done)return;var err=root.querySelector('#lt-lm-err');
      if(err&&!err.textContent){var mail='mailto:'+EM+'?subject='+encodeURIComponent('Logo mockup request: '+w)+'&body='+encodeURIComponent(body);
        err.innerHTML='Still sending… If a quick “I’m human” check popped up, finish it. Or <a href="'+mail+'">send by email</a>.';}
    },15000);
  }

  function openChat(){
    var T=window.tidioChatApi;
    if(T&&T.open){T.show&&T.show();T.open();return;}
    if(window.Tidio){Tidio.open();return;}if(window.$crisp){$crisp.push(['do','chat:open']);return;}
    if(window.Intercom){Intercom('show');return;}if(window.zE){zE('messenger','open');return;}
    window.location.href='mailto:'+EM;
  }

  // ============ Row updates: a click re-renders only its own keychain row ============
  function reRow(idx){
    var row=root.querySelector('.kc-row[data-row="'+idx+'"]');if(!row)return;
    var tmp=document.createElement('div');tmp.innerHTML=rKey(idx);
    var nr=tmp.firstChild;row.parentNode.replaceChild(nr,row);bindRow(nr);
  }
  function bindRow(row){
    var idx=parseInt(row.getAttribute('data-row'));
    var inp=row.querySelector('.lt-tg-inp');
    // Monogram letters are capitals; the Vine script keeps the case the buyer types
    if(inp)inp.addEventListener('input',function(){var kg=S.keys[idx];if(kg.k==='rect'&&kg.m!=='style-7'){var p=this.selectionStart;this.value=this.value.toUpperCase();try{this.setSelectionRange(p,p);}catch(x){}}kg.t=this.value;this.classList.remove('bad');var er=root.querySelector('#kc-err');if(er)er.textContent='';});
    row.querySelectorAll('[data-ty]').forEach(function(el){el.addEventListener('click',function(){
      var k=this.getAttribute('data-ty').split(':')[1],kg=S.keys[idx];if(kg.k===k)return;
      kg.k=k;kg.m=defM(k);if(kg.t.length>fm(k,kg.m).L)kg.t=kg.t.slice(0,fm(k,kg.m).L);reRow(idx);
    });});
    var gt=row.querySelector('.lt-gt');
    if(gt)gt.addEventListener('click',function(){S.keys[idx].g=!S.keys[idx].g;reRow(idx);});
    row.querySelectorAll('.lt-mt').forEach(function(el){el.addEventListener('click',function(){
      var kg=S.keys[idx];kg.m=this.getAttribute('data-mg').split(':')[1];
      var L=fm(kg.k,kg.m).L;if(kg.t.length>L)kg.t=kg.t.slice(0,L);reRow(idx);
    });});
    row.querySelectorAll('.lt-s').forEach(function(el){el.addEventListener('click',function(){S.keys[idx].c=this.getAttribute('data-cl').split(':')[1];reRow(idx);});});
    var ex=row.querySelector('[data-ex]');if(ex)ex.addEventListener('click',function(){S.keys[idx].e=true;reRow(idx);});
    var co=row.querySelector('[data-co]');if(co)co.addEventListener('click',function(){S.keys[idx].e=false;reRow(idx);});
  }

  function updateBulkPrice(){
    var wrap=root.querySelector('#lt-bp-wrap');if(!wrap)return;
    var n=parseInt(S.bq)||0,tr=tierFor(n);
    root.querySelectorAll('.lt-ch').forEach(function(el,j){el.classList.toggle('on',!!(tr&&tr.n===BK[j].n));});
    wrap.innerHTML=rBulkPrice();
    var ba=wrap.querySelector('#lt-ba');if(ba)ba.addEventListener('click',aBulk);
  }

  function bind(){
    root.querySelectorAll('.lt-tab').forEach(function(el){el.addEventListener('click',function(){S.m=this.getAttribute('data-m');R();});});
    root.querySelectorAll('.lt-tr').forEach(function(el){el.addEventListener('click',function(){S.ti=parseInt(this.getAttribute('data-ti'));mkK(RT[S.ti].q);R();});});
    root.querySelectorAll('.kc-row').forEach(bindRow);
    var gd=root.querySelector('#lt-gd');if(gd)gd.addEventListener('input',function(){S.gd=this.value;});
    var nt=root.querySelector('#kc-nt');if(nt)nt.addEventListener('input',function(){S.nt=this.value;});
    var ac=root.querySelector('#lt-ac');if(ac)ac.addEventListener('click',aRet);
    var bqi=root.querySelector('#lt-bqi');if(bqi)bqi.addEventListener('input',function(){S.bq=this.value;updateBulkPrice();});
    root.querySelectorAll('[data-bk]').forEach(function(el){el.addEventListener('click',function(){
      S.bk=this.getAttribute('data-bk');
      root.querySelectorAll('[data-bk]').forEach(function(b){b.classList.toggle('on',b.getAttribute('data-bk')===S.bk);});
      updateBulkPrice();
    });});
    var ba=root.querySelector('#lt-ba');if(ba)ba.addEventListener('click',aBulk);
    var ce=root.querySelector('#lt-eml');
    if(ce)ce.addEventListener('click',function(){
      function ok(){ce.textContent='✓ Copied!';setTimeout(function(){ce.textContent='✉️ Copy Email';},2000);}
      try{navigator.clipboard.writeText(EM).then(ok,function(){ce.textContent=EM;});}catch(x){ce.textContent=EM;}
    });
    var ch=root.querySelector('#lt-chat');if(ch)ch.addEventListener('click',openChat);
    bindLogo();
  }

  // ============ Add to cart ============
  // Line property per keychain: "GWH | Rectangle | Straight Font; All Caps (Style 4) | Gold | Caramel"
  function aRet(){
    var tr=RT[S.ti],v=fv(tr.vk),err=root.querySelector('#kc-err');
    if(!v){if(err)err.textContent='This set is unavailable right now. Please contact us.';return;}
    for(var j=0;j<tr.q;j++){
      if(!(S.keys[j].t||'').trim()){
        if(err)err.textContent='Please add the '+(S.keys[j].k==='rect'?'initials':'name')+' for keychain '+(j+1)+'.';
        var bad=root.querySelector('.lt-tg-inp[data-tg="'+j+'"]');if(bad){bad.classList.add('bad');bad.focus();}
        return;
      }
    }
    var props={};
    for(var i=0;i<tr.q;i++){
      var kg=S.keys[i],cl=fc(kg.c),mn=fm(kg.k,kg.m);
      props['Keychain '+(i+1)]=kg.t.trim()+' | '+(kg.k==='rect'?'Rectangle':'Loop')+' | '+mn.w+' | '+(kg.g?'Gold':'Plain')+' | '+cl.n;
    }
    if(S.nt.trim())props['Note']=S.nt.trim();
    if(S.gd.trim())props['Gift Deadline']=S.gd.trim();
    atc(v.id,1,props,'lt-ac');
  }

  function aBulk(){
    var n=parseInt(S.bq)||0;if(n<6)return;
    var tr=tierFor(n);if(!tr)return;
    var v=fv(tr.vk);if(!v)return;
    var props={Package:KT[S.bk].pk,Quantity:n+' keychains'};
    var dl=root.querySelector('#lt-bdl');if(dl&&dl.value)props['Deadline']=dl.value;
    atc(v.id,n,props,'lt-ba');
  }

  function atc(vid,qty,props,btnId){
    var btn=root.querySelector('#'+btnId);
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:qty,properties:props})})
    .then(function(r){if(!r.ok)throw new Error('cart_add_failed');return r.json();})
    .then(function(){return fetch('/cart.js').then(function(r){return r.json();});})
    .then(function(c){
      updateCartCount(c.item_count);
      if(btn){btn.classList.add('ok');btn.disabled=false;btn.innerHTML='✓ Added – view cart';btn.onclick=function(){window.location.href='/cart';};}
      showAddedModal(c.item_count);
    })
    .catch(function(e){
      console.error(e);
      if(btn){btn.disabled=false;btn.textContent='Add to Cart';}
      var err=root.querySelector('#kc-err');if(err)err.textContent='Something went wrong. Please try again.';
    });
  }

    function updateCartCount(n){
    var selectors=[
      '.cart-count','.cart-link__bubble','.cart-count-bubble',
      '[data-cart-count]','.cart-link span','.icon-cart-count',
      '.site-header__cart-count','.header__cart-count',
      '#CartCount','.cart-counter','.cart__count',
      'a[href="/cart"] .count','.header-cart-count','.cart-link .count'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        el.textContent=n;
        el.style.display='';
        el.classList.remove('hidden','hide');
      });
    });
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{count:n}}));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function showAddedModal(itemCount){
    var ex=document.getElementById('lt-modal');
    if(ex) ex.parentNode.removeChild(ex);

    var modal=document.createElement('div');
    modal.id='lt-modal';
    modal.className='lt-modal';
    modal.innerHTML=
      '<div class="lt-modal-bg"></div>'+
      '<div class="lt-modal-card">'+
        '<div class="lt-modal-icon">\u2713</div>'+
        '<h3 class="lt-modal-h">Added to your cart!</h3>'+
        '<p class="lt-modal-p">Your cart now has <strong>'+itemCount+' item'+(itemCount===1?'':'s')+'</strong>.</p>'+
        '<div class="lt-modal-bs">'+
          '<button class="lt-modal-b lt-modal-b-2" id="lt-modal-cont">Continue Shopping</button>'+
          '<button class="lt-modal-b lt-modal-b-1" id="lt-modal-go">Go to Cart \u2192</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(modal);
    requestAnimationFrame(function(){modal.classList.add('on');});

    function close(){
      modal.classList.remove('on');
      setTimeout(function(){if(modal.parentNode)modal.parentNode.removeChild(modal);},250);
    }
    modal.querySelector('.lt-modal-bg').addEventListener('click',close);
    modal.querySelector('#lt-modal-cont').addEventListener('click',close);
    modal.querySelector('#lt-modal-go').addEventListener('click',function(){window.location.href='/cart';});
    function escHandler(e){if(e.key==='Escape'){close();document.removeEventListener('keydown',escHandler);}}
    document.addEventListener('keydown',escHandler);
  }

  R();

  function initSw(){
    if(typeof Swiper==='undefined'){setTimeout(initSw,100);return;}
    if(!document.querySelector('.product-main-slider'))return;
    var th=null;
    if(document.querySelector('.product-thumb-slider')){
      th=new Swiper('.product-thumb-slider',{spaceBetween:10,slidesPerView:4,freeMode:true,watchSlidesProgress:true,loop:true,breakpoints:{640:{slidesPerView:5},768:{slidesPerView:6}}});
    }
    new Swiper('.product-main-slider',{spaceBetween:10,loop:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev'},pagination:{el:'.swiper-pagination',clickable:true},thumbs:th?{swiper:th}:null,zoom:{maxRatio:3,minRatio:1,toggle:true},on:{slideChange:function(){document.querySelectorAll('.product-main-slider video').forEach(function(v){v.pause();});var a=this.slides[this.activeIndex];if(a){var vid=a.querySelector('video');if(vid)vid.play().catch(function(){});}}}});
  }
  initSw();

  var rb=document.getElementById('read-more-btn'),rd=document.getElementById('product-description');
  if(rb&&rd){var rt=rd.querySelector('.description-text');if(rt&&rt.scrollHeight<=200)rb.style.display='none';rb.addEventListener('click',function(){rd.classList.toggle('expanded');this.querySelector('.read-more-text').textContent=rd.classList.contains('expanded')?'Read Less':'Read More';});}
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',kcInit);
    window.addEventListener('load',function(){
      var el=document.getElementById('kc-configurator');
      if(el&&!el.querySelector('.lt-tabs')){kcInit();}
    });
  } else {
    kcInit();
  }
})();
